module.exports = __webpack_public_path__ + "img/c594fc5d2b39b7dff37df2b81310454d.png";